import { useState } from "react";
import React from 'react'
import Dashboard from "./dashboard/Dashboard";
import { Route, Routes } from "react-router-dom";
import Sidebar from "../components/sidebar/Sidebar";
import './style.css'
import Sidebar2 from "../components/sidebar/Sidebar2";
import AllUser from "./all-users/AllUser";
import UpdateUser from "./profile-update/UpdateUser";
import UpdateWallet from "./wallet-update/UpdateWallet";
import Setting from "./settings/Setting";
import AllProducts from "./all-products/AllProducts";
import AddNewProduct from "./add-new-products/AddNewProduct";
import ProductInventoryUpdate from "./product-inventroy-update/ProductInventoryUpdate";
import UpdateProduct from "./update-product/UpdateProduct";
import AllOrders from "./all-orders/AllOrders";
import UpdateOrder from "./update-order/UpdateOrder";

function Admin() {

  const [isSidebar, setIsSidebar] = useState(true);

  return (
    <div className="mm-left">
      {isSidebar && <div className="admin-bg" onClick={()=>setIsSidebar(prev => !prev)}></div>}
      <Sidebar setIsSidebar={setIsSidebar} isSidebar={isSidebar} />

      <div className="admin-main-body">
      <Sidebar2 isSidebar={isSidebar} setIsSidebar={setIsSidebar} />
        <div className="admin-left">
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/settings" element={<Setting />} />
            <Route path="/all-users" element={<AllUser />} />
            <Route path="/update-user" element={<UpdateUser />} />
            <Route path="/update-wallet" element={<UpdateWallet />} />
            <Route path="/all-products" element={<AllProducts />} />
            <Route path="/add-products" element={<AddNewProduct />} />
            <Route path="/inventory-update" element={<ProductInventoryUpdate />} />
            <Route path="/update-product" element={<UpdateProduct />} />
            <Route path="/all-orders" element={<AllOrders />} />
            <Route path="/update-order" element={<UpdateOrder />} />
           
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default Admin;
